const locale = {
	VIEW_OPPORTUNITIES_TAB_KANBAN: 'Kanban',

	// #region Opportunities fields
	DETAILS_OPPORTUNITIES_FIELD_TITLE: 'Titolo',
	DETAILS_OPPORTUNITIES_FIELD_STATUS: 'Stato Opportunità',
	DETAILS_OPPORTUNITIES_FIELD_TYPE: 'Tipo Opportunità',
	DETAILS_OPPORTUNITIES_FIELD_COMPANY: 'Azienda',
	DETAILS_OPPORTUNITIES_FIELD_PERSON: 'Referente esterno',
	DETAILS_OPPORTUNITIES_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_OPPORTUNITIES_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_OPPORTUNITIES_FIELD_DATE_FROM: 'Data inizio',
	DETAILS_OPPORTUNITIES_FIELD_DATE_TO: 'Data fine',
	DETAILS_OPPORTUNITIES_FIELD_RATING: 'Temperatura',
	DETAILS_OPPORTUNITIES_FIELD_PLANNEDVALUE: 'Valore',
	DETAILS_OPPORTUNITIES_FIELD_EXPENSES: 'Spese',
	DETAILS_OPPORTUNITIES_FIELD_TAGS: 'Tag',
	DETAILS_OPPORTUNITIES_FIELD_WARNING: 'Warning',
	DETAILS_OPPORTUNITIES_FIELD_BLOCKED: 'Bloccato'
	// DETAILS_OPPORTUNITIES_FIELD_CLOSEDATE: 'Data chiusura',
	// #endregion
};

export default locale;
